import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { useQueryClient } from 'react-query';

import { NAVIGATION_DRAWER_WIDTH, STATUS } from '../utils/const';
import { setUserLanguage } from '../utils/language';
import { addAlert } from '../actions/alerts.action';
import { fetchAccountInfo } from '../actions/accountInfo.actions';
import { fetchEmployeeData } from '../actions/employee.action';
import { fetchObjective } from '../api/objective/objective.api';
import { getObjectiveRelationsByObjective } from '../api/objective/objectiveRelation.api';
import Header from './Header/Header';
import ObjectiveDialog from './Objectives/Dialog';
import ObjectiveSummary from './Objectives//ObjectiveItem/ObjectiveSummary';
import ObjectiveTabs from './Objectives/ObjectiveItem/Tabs';

const ObjectivePage = () => {
  const dispatch = useDispatch();
  const { objectiveId } = useParams();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const queryClient = useQueryClient();

  const employee = useSelector(state => state.employee);

  const [ drawerOpen, setDrawerOpen ] = useState(false);
  const [ updateDialogOpen, setUpdateDialogOpen ] = useState(false);

  useEffect(() => {
    dispatch(fetchAccountInfo());
    if (JSON.stringify(employee) === '{}') {
      dispatch(fetchEmployeeData()).then(employee => {
        setUserLanguage(employee.language);
      });
    }
  }, [ dispatch, employee ]);

  const objectiveQuery = useQuery(
    [ 'objective', objectiveId ],
    async () => {
      const { data } = await fetchObjective({
        objectiveId
      } );
      return data[0];
    }
  );
  const objective = objectiveQuery.data;
  const employeeIdOfCurrentUser = objective?.employee_id;

  const objectiveRelationsQuery = useQuery(
    [ 'objectiveRelations', objectiveId ],
    async () => {
      const { data } = await getObjectiveRelationsByObjective({
        objectiveId
      });
      return data;
    },
    {
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );
  const objectiveRelations = objectiveRelationsQuery.data ?? [];

  const onSubmitSuccess = () => {
    queryClient.invalidateQueries([ 'objective', objectiveId ]);
    queryClient.invalidateQueries([ 'objectiveRates', objectiveId ]);
  };

  const isEditable = objective?.status !== STATUS.COMPLETED &&
    objective?.status !== STATUS.FAILED && objective?.employee_id === objective?.proposed_by;

  return objective ? (
    <>
      <Header drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen }/>
      {objective &&
        <div style={ {
          padding: 16,
          marginLeft: !md ? 'auto' : drawerOpen ? `${NAVIGATION_DRAWER_WIDTH}px` : '55px'
        } }>
          <ObjectiveSummary
            objective={ objective }
            isEditable={ isEditable }
            setUpdateDialogOpen={ setUpdateDialogOpen }
            responsiveItems={ false }
          />
          <Grid container direction={ 'column' } >
            <ObjectiveTabs
              objectiveRelations={ objectiveRelations }
              objective={ objective }
              onSubmitSuccess={ onSubmitSuccess }
            />
          </Grid>
          <ObjectiveDialog
            open={ updateDialogOpen }
            handleClose={ () => setUpdateDialogOpen(false) }
            objectiveItem={ objective }
            employeeIdOfCurrentUser={ employeeIdOfCurrentUser }
            onSubmitSuccess={ onSubmitSuccess }
          />
        </div>
      }
    </>
  ) : null;
};

export default ObjectivePage;